import { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import useAuth from '@hooks/useAuth'
import Loader from '@components/Loader/Loader'

import loginVideoPoster from '@static/images/login/login-bg.webp'
import logo from '@static/vectors/logo-datalab.svg'
import './Login.css'

type LoginState = 'idle' | 'loading' | 'success' | 'error'

export default function Login() {
  const auth = useAuth()
  const [state, setState] = useState<LoginState>('idle')

  const handleSubmit = async (e) => {
    e.preventDefault()
    const formData = new FormData(e.currentTarget)
    const email = formData.get('email')

    if (typeof email === 'string' && email.length > 0) {
      try {
        setState('loading')
        await auth.requestEmail(email?.toLocaleLowerCase())
        setState('success')
      } catch (error) {
        console.warn('Login error:', error)
        setState('error')
      }
    }
  }

  return (
    <div className="page" id="login">
      <div className="split">
        <div className="item item-left">
          <img
            src={loginVideoPoster}
            alt="login animation fallback"
            aria-hidden="true"
          />
        </div>
        <div className="item item-right">
          <form id="login-card" onSubmit={handleSubmit}>
            <img src={logo} alt="datalab logo" />
            <h1>
              <FormattedMessage id="login.title" />
            </h1>
            <p>
              <span>
                <FormattedMessage id="login.text" />
              </span>
            </p>
            {state === 'loading' && (
              <div className="login-loading">
                <Loader />
              </div>
            )}
            {state === 'success' && (
              <div className="login--mail-sent">
                <FormattedMessage id="login.email.text" />
              </div>
            )}

            {(state === 'idle' || state === 'error') && (
              <>
                <label>
                  <strong>
                    <FormattedMessage id="login.label" />
                  </strong>
                  <input
                    required
                    type="email"
                    name="email"
                    placeholder="email@example.com"
                  />
                </label>

                {state === 'error' && (
                  <div className="error-message" role="alert">
                    <FormattedMessage id="login.error.generic" />
                  </div>
                )}
                <button className="cta-button">
                  <span className="icon icon-stars" />
                  <span>
                    <FormattedMessage id="login.cta-button" />
                  </span>
                </button>
              </>
            )}
          </form>
        </div>
      </div>
    </div>
  )
}
